/* Created by Interactive 63 - https://interactive63.com */
/**
 * Small inline SVG icons for the interface, drawn on a 16 px grid with currentColor.
 */
import { svgEl } from './dom';

export type IconName =
  | 'path'
  | 'group'
  | 'shape'
  | 'text'
  | 'image'
  | 'stop'
  | 'link'
  | 'chevron'
  | 'eye'
  | 'eye-off'
  | 'export'
  | 'export-off'
  | 'plus'
  | 'minus';

const PATHS: Record<IconName, string> = {
  path: 'M2 12 C5 2, 9 14, 14 4',
  group: 'M2 4h4l1.5 1.5H14V13H2z',
  shape: 'M3 3h10v10H3z',
  text: 'M3 4h10M8 4v9M6 13h4',
  image: 'M2 3h12v10H2zM2 11l4-4 3 3 2-2 3 3',
  stop: 'M8 2l5 6-5 6-5-6z',
  link: 'M6 10l4-4M5 8L3.5 9.5a2.1 2.1 0 003 3L8 11M11 8l1.5-1.5a2.1 2.1 0 00-3-3L8 5',
  chevron: 'M6 4l4 4-4 4',
  eye: 'M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM8 6a2 2 0 100 4 2 2 0 000-4z',
  'eye-off': 'M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8zM3 13L13 3',
  export: 'M3 3h10v10H3zM6 8h4',
  'export-off': 'M3 3h10v10H3zM6 8h4M2 14L14 2',
  plus: 'M8 3v10M3 8h10',
  minus: 'M3 8h10',
};

/** Creates an icon element. Icons are decorative; labels belong on the surrounding control. */
export function icon(name: IconName): SVGSVGElement {
  return svgEl(
    'svg',
    {
      viewBox: '0 0 16 16',
      width: 16,
      height: 16,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 1.4,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'aria-hidden': 'true',
      class: 'icon',
    },
    svgEl('path', { d: PATHS[name] }),
  );
}

/** Chooses the layer icon for an element tag. */
export function iconForTag(tag: string): IconName {
  switch (tag) {
    case 'g':
    case 'svg':
      return 'group';
    case 'text':
    case 'tspan':
      return 'text';
    case 'image':
      return 'image';
    case 'stop':
      return 'stop';
    case 'a':
    case 'use':
      return 'link';
    case 'path':
    case 'line':
    case 'polyline':
    case 'polygon':
      return 'path';
    default:
      return 'shape';
  }
}
